// Locally optimised WebP variants generated by scripts/optimize_images.py.
const SIZES = {
  hero: [640, 1024, 1600],
  "service-car": [600, 900, 1200],
  "service-sofa": [600, 900, 1200],
  "ba-car-before": [640, 1024, 1280],
  "ba-car-after": [640, 1024, 1280],
  "ba-sofa-before": [640, 1024, 1280],
  "ba-sofa-after": [640, 1024, 1280],
  "academy-certificate": [640, 1024, 1400],
};

export const IMG_DIMS = {
  hero: [2400, 3001],
  "service-car": [1200, 1500],
  "service-sofa": [1200, 800],
  "ba-car-before": [1280, 720],
  "ba-car-after": [1280, 720],
  "ba-sofa-before": [1280, 853],
  "ba-sofa-after": [1280, 853],
  "academy-certificate": [1492, 1054],
};

export const localImg = (name, sizes) => {
  const list = SIZES[name];
  return {
    src: `/img/${name}-${list[list.length - 1]}.webp`,
    srcSet: list.map((w) => `/img/${name}-${w}.webp ${w}w`).join(", "),
    sizes,
    width: IMG_DIMS[name][0],
    height: IMG_DIMS[name][1],
  };
};

// Server-side resized variant of an uploaded portfolio image (/api/uploads/…).
export const uploadVariant = (url, w) => {
  if (typeof url !== "string" || !url.includes("/api/uploads/")) return url;
  return `${url}${url.includes("?") ? "&" : "?"}w=${w}`;
};

export const uploadSrcSet = (url, widths = [480, 960, 1600]) =>
  url && url.includes("/api/uploads/") ? widths.map((w) => `${uploadVariant(url, w)} ${w}w`).join(", ") : undefined;
